<template>
  <div>
    <button type="button" @click="jump()">跳转page02</button>
    <br />
    <br />
    <button type="button" @click="pop()">弹出page02</button>
    <br />
    <br />
    <page2 v-if="flag"></page2>
  </div>
</template>

<script>
import page2 from "./page02"
export default {
  components:{
    page2
  },
  data() {
    return {
      flag: false
    }
  },
  methods:{
    jump(){
      this.$router.push({path:'/page02'})
    },
    pop(){
      this.flag = !this.flag
    }
  },
  mounted() {
    console.log("page01.mounted...")
  },
  created(){
    console.log("page01.created...")
  },
}
</script>

<style>
